import { GetStaticPaths, GetStaticProps, NextPage } from 'next'
import React from 'react'
import AboutPage from '../../components/text-pages/AboutPage/AboutPage'
import { HeaderColors } from '../../components/types'
import AboutProvider from '../../contexts/aboutProvider'
import { initializeApollo } from '../../lib/apolloClient'
import globalCache from '../../lib/globalCache'
import { getAboutPageVariables } from '../../lib/gql'
import { ABOUT } from '../../queries/aboutQuery'
import { about, aboutVariables } from '../../__generated__/about'

const About: NextPage<{ code: string }> = ({ code }) => {
  return (
    <AboutProvider code={code}>
      <AboutPage />
    </AboutProvider>
  )
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const apolloClient = initializeApollo()
  await globalCache(apolloClient)

  const data = await apolloClient.query<about, aboutVariables>({
    query: ABOUT,
    variables: getAboutPageVariables(params.code as string),
  })

  if (!data.data) {
    return {
      notFound: true,
      revalidate: 60,
    }
  }

  const seo = {
    title: data?.data?.element?.seo?.elementMetaTitle,
    description: data?.data?.element?.seo?.elementMetaDescription,
    keywords: data?.data?.element?.seo?.elementMetaKeywords,
  }

  return {
    props: {
      __APOLLO_STATE__: apolloClient.cache.extract(),
      code: params.code as string,
      headerInitColor: HeaderColors.white,
      seo,
    },
    revalidate: 60,
  }
}
export const getStaticPaths: GetStaticPaths = async () => {
  const paths: { params: { section: string; path: string[] } }[] = []
  return {
    paths,
    fallback: 'blocking',
  }
}
export default About
